import React from 'react';

const Hero = ({ onBookNowClick }) => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToBooking = () => {
    if (onBookNowClick) {
      onBookNowClick();
    } else {
      scrollTo('book');
    }
  };

  const overlay = "absolute bg-transparent border-0 cursor-pointer z-10";

  return (
    <section className="relative w-full overflow-hidden bg-[#001f3f]">
      <img
        src="/design-master/hero-master-artwork.png"
        alt="Kyle Drive — Real Driving. Real Experience."
        className="block w-full h-auto"
      />

      {/* Baked-in hero navigation */}
      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Home"
        className={overlay}
        style={{ left: '30%', top: '8%', width: '5.5%', height: '9%' }}
      />

      <button
        type="button"
        onClick={() => scrollTo('facilities')}
        aria-label="About Kyle Drive"
        className={overlay}
        style={{ left: '36%', top: '8%', width: '5.5%', height: '9%' }}
      />

      <button
        type="button"
        onClick={() => scrollTo('facilities')}
        aria-label="Venue"
        className={overlay}
        style={{ left: '42%', top: '8%', width: '5.5%', height: '9%' }}
      />

      <button
        type="button"
        onClick={() => scrollTo('facilities')}
        aria-label="Facilities"
        className={overlay}
        style={{ left: '48%', top: '8%', width: '7%', height: '9%' }}
      />

      <button
        type="button"
        onClick={scrollToBooking}
        aria-label="Book Now"
        className={overlay}
        style={{ left: '55.5%', top: '8%', width: '7%', height: '9%' }}
      />

      <button
        type="button"
        onClick={() => scrollTo('contact')}
        aria-label="Contact"
        className={overlay}
        style={{ left: '63%', top: '8%', width: '6.5%', height: '9%' }}
      />

      {/* Baked-in top-right Book Now */}
      <button
        type="button"
        onClick={scrollToBooking}
        aria-label="Book Now"
        className={overlay}
        style={{ left: '83%', top: '5%', width: '14%', height: '14%' }}
      />

      {/* Baked-in Book a Session */}
      <button
        type="button"
        onClick={scrollToBooking}
        aria-label="Book a Session"
        className={overlay}
        style={{
          left: '6.5%',
          top: '72%',
          width: '25.5%',
          height: '16%'
        }}
      />

      {/* Baked-in Learn More */}
      <button
        type="button"
        onClick={() => scrollTo('facilities')}
        aria-label="Learn More"
        className={overlay}
        style={{
          left: '33.5%',
          top: '72%',
          width: '19.5%',
          height: '16%'
        }}
      />
    </section>
  );
};

export default Hero;
